<div class="searchBarBusesMobile__cont" [class.results]="isResultsPage">
  <div class="searchBarBusesMobile__scrolling" [class.results]="isResultsPage">
    <div class="searchBarBusesMobile__radios">
      <div class="searchBarBusesMobile__radio" *ngFor="let type of flightTypes">
        <app-ds-radio-button
          [checked]="isActiveBusType(type)"
          [title]="{ Label: 'SEARCH_MODULE.FLIGHT_TYPE.' + type | transloco }"
          (radioOnChecked)="busTypeSelected(type)">
        </app-ds-radio-button>
      </div>
    </div>
    <div class="travel-destination-cont">
      <app-search-place-input
        [searchType]="searchType"
        [isMobile]="true"
        [showError]="isEmptyDeparturePlace"
        [icon]="icons.StartPoint"
        [placeType]="departure"
        [place]="departurePlace"
        [samePlaceError]="samePlaceError"
        [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.FROM' | transloco"
        [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_ORIGIN_MOBILE' | transloco"
        [autoCompletePlaces]="autoCompletePlaces"
        [eventPath]="eventPath | async"
        (selectPlace)="selectPlace.emit($event)"
        [autofocus]=true
        [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
        [arrivalPlace]="arrivalPlace"
        [departurePlace]="departurePlace"
        (inputChanged)="placeInputChanged.emit($event)"
        (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
        (locationNotFoundEvent)="locationNotFoundEvent($event)"
        (popularSelected)="popularSelectedEvent($event)">
      </app-search-place-input>
      <div class="searchBarBusesMobile__swipe-locations">
        <app-ds-button-icon
          [buttonSize]="buttonIconSize"
          [icon]="arrowIcon"
          (clickEvent)="swapLocations()">
        </app-ds-button-icon>
      </div>
      <app-search-place-input
        [searchType]="searchType"
        [showError]="isValidArrivalPlace"
        [isMobile]="true"
        [autofocus]=true
        [icon]="icons.Location"
        [placeType]="arrival"
        [place]="arrivalPlace"
        [samePlaceError]="samePlaceError"
        [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
        [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
        [autoCompletePlaces]="autoCompletePlaces"
        [eventPath]="eventPath | async"
        (selectPlace)="selectPlace.emit($event)"
        [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
        [arrivalPlace]="arrivalPlace"
        [departurePlace]="departurePlace"
        (inputChanged)="placeInputChanged.emit($event)"
        (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
        (locationNotFoundEvent)="locationNotFoundEvent($event)"
        (popularSelected)="popularSelectedEvent($event)">
      </app-search-place-input>
    </div>
    <div class="travel-calendar-input-cont">
      <app-search-bar-input
        [showError]="isEmptyDepartureDate"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
        [placeholder]="'DATE' | transloco"
        [value]="departureDate | flightDate"
        [icon]="icons.Calendar"
        (isFocus)="showMobileCalendar(calendarField.departure)"
        [readOnly]="true"
        [isMobile]="true"
        [swapPlaceholder]="true">
      </app-search-bar-input>
      <app-search-bar-input
        [showError]="isEmptyArrivalDate"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
        [placeholder]="'DATE' | transloco"
        [value]="arrivalDate | flightDate"
        [icon]="icons.Calendar"
        [disabled]="isOneWayTrip"
        (isFocus)="showMobileCalendar(calendarField.arrival)"
        [isMobile]="true"
        [swapPlaceholder]="true">
      </app-search-bar-input>
    </div>
    <div class="travel-destination-cont">
      <app-search-bar-input
        (isFocus)="toggleBusOption('PASSENGER_ARRANGEMENT')"
        [icon]="icons.ChevronFilledDown"
        [id]="'passenger-input'"
        [isPassengerField]="true"
        [label]="'SEARCH_MODULE.PASSENGERS' | transloco"
        [readOnly]="true"
        [searchType]="searchType"
        [isMobile]="true"
        [value]="passengerArrangementOnlySeats | passengerInput : searchType">
      </app-search-bar-input>
    </div>
  </div>
  <div class="searchBarBusesMobile__searchBtn" >
    <app-fixed-surface
      [boxShadow]="true">
      <app-ds-button
        [isLoading]="searching"
        [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
        (clickEvent)="searchBuses()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</div>

<app-swipe-up
  [showSwipeUp]="showBusOptionSelection"
  (toggleShowSwipeUp)="toggleBusOption()">
  <div content [ngSwitch]="activeOption" class="buses-options-cont">
    <ng-container *ngSwitchCase="'FLIGHT_TYPE'">
      <h2>{{'SEARCH_MODULE.TICKETS'| transloco}}</h2>
      <p
        *ngFor="let type of flightTypes"
        [class.active]="isActiveBusType(type)"
        (click)="busTypeSelected(type)">
        {{'SEARCH_MODULE.FLIGHT_TYPE.' + type | transloco}}
      </p>
    </ng-container>
    <ng-container *ngSwitchCase="'PASSENGER_ARRANGEMENT'">
      <ng-container *ngTemplateOutlet="passengerSelection"></ng-container>
    </ng-container>
  </div>
</app-swipe-up>

<ng-template #passengerSelection>
  <app-search-bar-passenger-selection
    [isMobile]="true"
    [searchType]="searchType"
    [seatsOnly]="true"
    [activeOption]="activeOption"
    [eventPath]="eventPath | async"
    [passengerArrangement]="passengerArrangementOnlySeats"
    (emitArrangement)="emitArrangement.emit($event)"
    (emitApplySelection)="toggleBusOption()">
  </app-search-bar-passenger-selection>
</ng-template>